import React from 'react';
import classNames from 'classnames';

/**
 * NackleNotation component for displaying an icon with accompanying text.
 *
 * @module NackleNotation
 * @param {Object} props - The component props
 * @param {string} [props.className] - Additional CSS class names to apply to the component
 * @param {React.ReactNode} [props.icon] - The icon element to display
 * @param {string} props.text - The text to display next to the icon
 * @param {boolean} [props.emphasis] - Whether to apply emphasis styling
 * @param {string} [props.state] - State-based styling to apply to the component
 * @returns {React.ReactElement} A div containing the icon and text
 */
const NackleNotation = ( { className, icon, text, emphasis, state } ) => {
    const tileClasses = classNames( {
        'nackle-notation': true,
        'emphasis': emphasis ? true : false,
        [ state ]: state ? true : false,
        [ className ]: className ? true : false,
        'has-icon': icon ? true : false
    } );
    return (
        <div className={ tileClasses } role="alert" >
            <div className="notation-icon">
                { icon ? icon : null }
            </div>
            <div className="notation-text">
                { text }
            </div>
        </div>
    );
};

export { NackleNotation };